import React, { useEffect, useState, useContext, useRef } from 'react';
import * as THREE from 'three';
import { Canvas } from '@react-three/fiber';

import { PlacementHelperMesh } from './geometry-components/PlacementHelperMesh';
import ModelManagerComponent from './ModelManagerComponent';

import LayerMappingsEnum from '../enums/LayerMappingsEnum';

import { sceneUnitsFromMm } from '../utils/scaler';

import SceneDirector from './SceneDirector';
import StageManager from './StageManager';
import DebugHelper from './debug-components/DebugHelper';
import CommandManager from './functional-components/CommandManager';
import InputListenerComponent from './functional-components/InputListenerComponent';
import { SceneManager } from '../model/SceneManager';
import ApartmentNamesComponent from './text-components/ApartmentNamesComponent';
import EditHandleTooltipComponent from './text-components/EditHandleTooltipComponent';
import RoomNoteTooltipComponent from './text-components/RoomNoteTooltipComponent';
import SceneDocumentManagerComponent from './functional-components/SceneDocumentManagerComponent';
import DocumentManagerUiComponent from './functional-components/DocumentManagerUiComponent';
import SharedMaterialsStateProvider from '../store/sharedMaterialsState/SharedMaterialsStateProvider';
import CommandToolBarComponent from './ui/CommandToolBarComponent';

const ApartmentViewer: React.FC = () => {

  // https://r3f.docs.pmnd.rs/advanced/scaling-performance#re-using-geometries-and-materials
  THREE.ColorManagement.enabled = true

  const debugLayers = new THREE.Layers();
  debugLayers.set(LayerMappingsEnum.DebugEntities);

  return (
    <>
      
        <Canvas className="sfpViewerCanvas"
                gl={{ preserveDrawingBuffer: true }}
                onCreated={({ scene, gl }) => {
                  SceneManager.scene = scene;
                  SceneManager.gl = gl;
                  scene.name = "SFP - ApartmentViewer Scene";
                }} >

          {/* Origo */}
          <PlacementHelperMesh
            name="Origo Placement Helper"
            location={new THREE.Vector3(0,0,0)} 
            refDirection={new THREE.Vector3(1,0,0)}
            axis={new THREE.Vector3(0,0,1)}
            helperSize={sceneUnitsFromMm(1000)}
            layers={debugLayers}
             />
          
          <StageManager />
          <SceneDirector />
          {/* <ModelPresenter /> */}
          
            <ModelManagerComponent />
          
          <DebugHelper />
          <CommandManager />
          <InputListenerComponent />

          <ApartmentNamesComponent />
          <EditHandleTooltipComponent />
          <RoomNoteTooltipComponent />

          <SceneDocumentManagerComponent />

        </Canvas>
    </>
  );
}

export default ApartmentViewer;

